import { ActAsCandidate, ActAsSession } from "core/types/act-as.types";
import { ApiFactoryClients } from "../api.types";
import {
  transformActAsCandidate,
  transformActAsSession,
} from "./act-as.helpers";

// Contratto con il backend (routes/ActAs.py, tutte @legal_auth: un 'user' non le
// raggiunge nemmeno, e legal_auth non passa mai per _resolve_act_as — quindi una
// delega non puo' aprirne un'altra):
//
//   GET  /legals/users   -> [{id, name, lastname, email, enabled, emailVerified}]
//                           (UserModel.get_all_users_basic: niente billing, niente N+1)
//   GET  /legals/act-as  -> {enabled, sessions: [sessione aperta, ...]}
//   POST /legals/act-as  {action: "start", subject_id, reason, ttl_minutes?} -> sessione
//                           (reason obbligatorio; il target deve essere un cliente:
//                            verso un altro legals/admin il backend risponde 400)
//   POST /legals/act-as  {action: "stop", session_id} -> {closed, id}
//
// Lo stop e' reale: chiusa la riga, l'header X-Act-As diventa inerte all'istante, senza
// aspettare la scadenza e senza dover invalidare nessun token.

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ codeHttpClient }: ApiFactoryClients<"codeHttpClient">) => ({
  listCandidates: (): Promise<ActAsCandidate[]> =>
    codeHttpClient
      .get("/legals/users")
      .then(({ data }) =>
        (data ?? []).map((d: any) => transformActAsCandidate(d))
      ),
  // Sessioni aperte secondo il SERVER: e' l'unica verita' che conta per sapere se la
  // delega e' ancora viva (puo' essere stata chiusa da un'altra scheda o scaduta).
  getOpenSessions: (): Promise<ActAsSession[]> =>
    codeHttpClient
      .get("/legals/act-as")
      .then(({ data }) =>
        (data?.sessions ?? []).map((d: any) => transformActAsSession(d))
      ),
  start: (
    subjectId: string,
    // obbligatorio: open_session rifiuta senza motivo (audit GDPR)
    reason: string,
    ttlMinutes?: number
  ): Promise<ActAsSession> =>
    codeHttpClient
      .post("/legals/act-as", {
        action: "start",
        subject_id: subjectId,
        reason,
        ttl_minutes: ttlMinutes,
      })
      .then(({ data }) => transformActAsSession(data)),
  stop: (sessionId: string) =>
    codeHttpClient.post("/legals/act-as", {
      action: "stop",
      session_id: sessionId,
    }),
});
